import { ImagePrimitive, ResponsiveContainer, styled } from '@arpeggi/ui'
import { FC } from 'react'

const Root = styled('div', {
  overflow: 'hidden',
  position: 'relative'
})

const Flare: FC<{ type: 'one' | 'two' }> = ({ type }) => {
  const src = type === 'one' ? '/static/images/flare1.png' : '/static/images/flare2.png'
  const css = type === 'one' ? { top: '-100px', left: '-300px' } : { top: '350px', right: '-300px' }
  return (
    <ImagePrimitive.Root css={{ position: 'absolute', width: '700px', height: '700px', ...css }}>
      <ImagePrimitive.Image src={src} />
    </ImagePrimitive.Root>
  )
}

const Header = styled(ResponsiveContainer, {
  paddingTop: '40px',
  paddingBottom: '40px',
  position: 'relative'
})

const Divider = styled('div', {
  borderBottomStyle: 'solid',
  borderBottomColor: '$blackA100',
  borderBottomWidth: '1px'
})

const Title = styled('div', {
  color: '$black',
  text: '36',
  fontWeight: 'bold',
  textAlign: 'center',
  marginBottom: '4px'
})

const Subtitle = styled('p', {
  color: '$blackA500',
  text: '18',
  textAlign: 'center',
  marginBottom: '24px'
})

const SearchContainer = styled('div', {
  maxWidth: '700px',
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
})

const Content = styled(ResponsiveContainer, {
  minHeight: '100vh',
  paddingTop: '24px',
  position: 'relative'
})

export const Page = { Root, Header, Flare, Title, Subtitle, Content, Divider, SearchContainer }
